import React from 'react';

import { valueOrPlaceholder } from 'helpers/string_helpers';

interface Props {
  comp: {
    customFieldValues: {
      schemaSlug: string;
      value?: string;
    }[];
  };
  slug: string;
}

export default function CompCustomFieldValueCell({ comp, slug }: Props) {
  const customFieldValue = comp.customFieldValues.find(value => value.schemaSlug === slug);

  return (
    <td className="hidden-xs hidden-sm">
      <div className="one-line">
        {valueOrPlaceholder(customFieldValue?.value)}
      </div>
    </td>
  );
}

export function isCustomFieldSlug(slug: string) {
  return slug.startsWith('c_');
}
